import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitlesBig from "./PageTitlesBig";
import PageTitles from "./PageTitles";
import PageTitlesSM from "./PageTitlesSM";


const ActividadesSites = () => {
    const navigate = useNavigate();

    const selectActividadClick = (actividad) => {
        localStorage.setItem("Actividad-Club", actividad);
        navigate("/actividaddetalle");
    }
    return (
        <>
        <main>
      <div class="container text-center mainContent" >
        {/*<PageTitlesBig texto="Clubes Municipales"  icono="./icon_header_clubes.svg" retorno="/"/>*/}
        <PageTitlesSM  texto="Clubes Municipales"  icono="./icon_header_clubes.svg" retorno="/"/>
    <div class="col clubTextTitle">Por favor seleccione el polideportivo</div>
   
<div class="despl height400">   
     <div class="row">
        <div class="col">
                     <img src="./icon_club_menu_luchetti_pn.png" class="clubMenu" onClick={()=>selectActividadClick("Luchetti")}/>

        </div>
        </div>
        <div class="row">
        <div class="col">
            <img src="./icon_club_menu_derqui_pn.png" class="clubMenu" onClick={()=>selectActividadClick("Derqui")}/>
        </div>
        </div>
        <div class="row">
        <div class="col">
            <img src="./icon_club_menu_delviso_pn.png" class="clubMenu" onClick={()=>selectActividadClick("Del Viso")}/>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <img src="./icon_club_menu_peruzzotti_pn.png" class="clubMenu" onClick={()=>selectActividadClick("Peruzzotti")}/>
        </div>
        </div>
        <div class="row">
        <div class="col">
            <img src="./icon_club_menu_alberti_pn.png" class="clubMenu" onClick={()=>selectActividadClick("Alberti")}/>
        </div>
        </div>
        <div class="row">
        <div class="col">
            <img src="./icon_club_menu_lagomarsino_pn.png" class="clubMenu" onClick={()=>selectActividadClick("Lagomarsino")}/>
        </div>
        </div>
        <div class="row">
        <div class="col">
            <img src="./icon_club_menu_tribarrial_pn.png" class="clubMenu" onClick={()=>selectActividadClick("Tribarrial")}/>
        </div>
        </div>
        <div class="row">
        <div class="col">
            <img src="./icon_club_menu_astolfi_manzone_pn.png" class="clubMenu" onClick={()=>selectActividadClick("Astolfi-Manzone")}/>
        </div>
        </div>
    <div  class="height100">
        &nbsp;

    </div>
    </div>
</div>
</main>  
        </>

    );
    }
export default ActividadesSites;